const e = {
  add: "Tilføj",
  cancel: "Annuller",
  clear: "Fjern",
  confirm: "Bekræft",
  delete: "Slet",
  redo: "Lav om",
  save: "Gem",
  saveAs: "Gem som",
  undo: "Fortryd"
}, t = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, a = {
  cancel: "Annuller",
  confirm: "Bekræft",
  datePlaceholder: "Vælg dato",
  datetimePlaceholder: "Vælg dato og tidspunkt",
  endDatePlaceholder: "Slutdato",
  endDatetimePlaceholder: "Slutdato- og tidspunkt",
  endMonthPlaceholder: "Slutningen af måneden",
  monthPlaceholder: "Vælg måned",
  now: "Nu",
  quarterPlaceholder: "Vælg kvartal",
  selectDate: "Vælg dato",
  selectTime: "Vælg tidspunkt",
  startDatePlaceholder: "Startdato",
  startDatetimePlaceholder: "Startdato- og tidspunkt",
  startMonthPlaceholder: "Startmåned",
  today: "I dag",
  weekPlaceholder: "Vælg uge",
  yearPlaceholder: "Vælg år",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, l = {
  placeholder: "Vælg"
}, n = {
  clear: "Fjern",
  negativeText: "Annuller",
  now: "Nu",
  placeholder: "Vælg tidspunkt",
  positiveText: "Ok"
}, r = {
  placeholder: "Indtast"
}, o = {
  placeholder: "Indtast"
}, d = {
  placeholder: "Begynd at skrive ..."
}, s = {
  allRows: "Alle rækker",
  default: "Standard",
  deleteLayoutDescription: "Er du sikker på, at du vil slette denne tilpasning af indhold?",
  discardChanges: "Kassér ændringer",
  discardLayoutChanges: "Kassér layoutændringer",
  enterLayoutName: "Indtast tilpasning af indholdsnavn",
  enterRowNumber: "Indtast antal af rækker",
  fieldsSelected: "valgte felter",
  freezeColumnDescription: "Frys kolonnen til venstre",
  freezeUptoColumn: "Frys op til kolonne",
  frozen: "Frossen",
  layoutName: "Tilpasning af indholds-navn",
  manageColumns: "Administrer kolonner",
  none: "Ingen",
  reorderRows: "Ændring af rækkefølge for rækker",
  rowsSelected: "rækker udvalgt",
  saveLayoutAs: "Gem tilpasning af indhold som",
  saveLayoutNew: "Gem ny tilpasning af indhold",
  search: "Søg",
  searchColumnsPlaceholder: "Søgekolonner",
  searchFieldsPlaceholder: "Søgefelter",
  selectAll: "Vælg alle",
  setTableHeight: "Indstil tabelhøjde",
  unfreeze: "Frigør",
  unsavedChanges: "Du har ændringer, der ikke er gemt",
  unsavedChangesDescription: "Der kan være en eller flere ændringer, der ikke er gemt. Ønsker du at gemme dem?"
}, i = {
  at: "ved",
  colorAlreadyUsed: "Vælg en anden farve, eller brug den aktuelle",
  colorNamePlaceholder: "Indtast navn",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Vælg et andet farvenavn",
  noColorsAdded: "Du har ingen farver i denne sektion."
}, c = {
  searchPlaceholder: "Søg"
}, g = {
  invalidPastedData: "Ugyldige indsatte data"
}, p = {
  of: "af",
  page: "Side",
  rowsPerPage: "Rækker pr. side"
}, u = {
  failedToUpload: "Kunne ikke uploade",
  retry: "Prøv igen",
  clickToUpload: "klik for at Upload",
  orDragAndDrop: "Eller Træk og slip",
  supportedFileTypes: "Understøttede filtyper:"
}, k = {
  global: e,
  Progress: t,
  DatePicker: a,
  Select: l,
  TimePicker: n,
  Input: r,
  InputNumber: o,
  InputTag: d,
  HLDataTable: s,
  ColorPicker: i,
  InputPhone: c,
  InputOtp: g,
  Pagination: p,
  Upload: u
};
export {
  i as ColorPicker,
  a as DatePicker,
  s as HLDataTable,
  r as Input,
  o as InputNumber,
  g as InputOtp,
  c as InputPhone,
  d as InputTag,
  p as Pagination,
  t as Progress,
  l as Select,
  n as TimePicker,
  u as Upload,
  k as default,
  e as global
};
